module.exports = __webpack_public_path__ + "static/img/papapa.b0c0c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/papapa.png
// module id = XHE4
// module chunks = 0